/**
  A helper function to add developer warnings to Design System components.
  This is useful to alert developers about unstable APIs or patterns
 */
export const devAlert = (condition: boolean, message: string): null => {
  if (process.env.NODE_ENV === 'development') {
    if (condition) {
      console.warn(`[DESIGN-SYSTEM WARNING]
    ${message}`);
    }
  }
  return null;
};
